import React, { useContext, useEffect, useState } from "react";
import VehicleDA_VehiclePerDriver from "./VehicleSelectVehicle/VehicleDA_VehiclePerDriver";
import { storageData } from "services/Services";
import VehicleDA_DriverPerVehicle from "./VehicleSelectVehicle/VehicleDA_DriverPerVehicle";

export const VehicleDA_SaveContext = React.createContext()

const VehicleDA_SelectVehicle = ({ vehReqContext, reqVehicleClass, setVehicleClass, requestType }) => {
    const context = useContext(vehReqContext);
    const [drivers, setDrivers] = useState(context[reqVehicleClass]?.driverAssignment?.drivers); //driverList
    const [vehicles, setVehicles] = useState(context[reqVehicleClass]?.driverAssignment?.vehicles); //vehicleList
    const [dob, setDob] = useState("");

    //Check that new vehicle is at the top of list.
    var combinedVehicles = []
    if (requestType == "AddVehicle") {
        combinedVehicles = [...context[reqVehicleClass]?.vehicles?.vehiclesOnPolicy?.newVehicles, ...context[reqVehicleClass]?.vehicles?.vehiclesOnPolicy?.storedVehicles]; //JSON.parse(localStorage.getItem("storedVehicles"));
    }
    else if (requestType == "RemoveVehicle") {
        combinedVehicles = [...context[reqVehicleClass]?.vehicles?.vehiclesOnPolicy?.removedVehicles, ...context[reqVehicleClass]?.vehicles?.vehiclesOnPolicy?.storedVehicles]; //JSON.parse(localStorage.getItem("storedVehicles"));
    }
    else if (requestType == "AddressChange" || requestType == "HouseholdChange") {
        combinedVehicles = [...context[reqVehicleClass]?.vehicles?.vehiclesOnPolicy?.storedVehicles];
    }
    combinedVehicles = combinedVehicles.filter((vehicle, id) => vehicle?.type != "remove");

    // Adds count for clear button
    const checkForClearButton = () => {
        var driverClear = 0
        for (var i = 0; i < vehicles.length; i++) {
            if (vehicles[i]?.driverName && "driverName" in vehicles[i]) { driverClear++ }
            if (vehicles[i]?.otherDriverSelected && "otherDriverSelected" in vehicles[i]) { driverClear++ }
        }
        if (driverClear > 0) { return true }
        return false
    }

    const [showClear, setShowClear] = useState(checkForClearButton())

    // Saves driver to vehicle
    const saveDriverToVehicle = (vehicleIndex, driver) => {
        var vehicleListCopy = vehicles
        vehicleListCopy[vehicleIndex]["otherDriverSelected"] = (driver == "OtherDriver") ? "Yes" : "No"
        vehicleListCopy[vehicleIndex]["driverName"] = driver.fullName
        vehicleListCopy[vehicleIndex]["driverDOB"] = driver.DOB
        vehicleListCopy[vehicleIndex]["driverDLN"] = driver.licenseNum
        delete vehicleListCopy[vehicleIndex]["vehicleType"]

        if (requestType == "RemoveVehicle") {
            vehicleListCopy[vehicleIndex]["garaged"] = context?.setGaragedToBit(context[reqVehicleClass]?.driverAssignment?.keptOvernight)
        }
        updateVehicleClass(vehicleListCopy)
    }

    // Handles Single Driver Fields
    const handleSingleField = (key, value, vehicleIndex) => {
        var vehicleListCopy = vehicles
        vehicleListCopy[vehicleIndex][key] = value
        updateVehicleClass(vehicleListCopy)
    }

    // Update add vehicle class
    const updateVehicleClass = (vehicleListCopy) => {
        setVehicles([...vehicleListCopy])

        var vehicleClassCopy = context[reqVehicleClass]
        var vehicleDriversCopy = vehicleClassCopy.driverAssignment.vehicles
        vehicleDriversCopy = vehicles
        vehicleClassCopy.driverAssignment.vehicles = vehicleDriversCopy

        setVehicleClass({ ...vehicleClassCopy })
        storageData.setItem(requestType + 'Class', JSON.stringify(vehicleClassCopy))
        setShowClear(checkForClearButton())
    }

    // Clears all vehicle selected for each driver
    const clearDriverSelections = () => {
        var vehicleListCopy = vehicles
        for (var i = 0; i < vehicleListCopy?.length; i++) {
            delete vehicleListCopy[i]?.driverName
            delete vehicleListCopy[i]?.driverDOB
            delete vehicleListCopy[i]?.driverDLN
            delete vehicleListCopy[i]?.otherDriverSelected
            delete vehicleListCopy[i]?.vehicleType
        }

        setVehicles([...vehicleListCopy])
        setShowClear(false)
    }

    useEffect(() => {
        // Adds added driver to list and driver assignment for address/household change class
        if (requestType === "AddressChange" || requestType === "HouseholdChange") {
            var addedDrivers = context[reqVehicleClass]?.driversHHMs?.drivers?.newDrivers;
            var addedHhmAsDrivers = context[reqVehicleClass]?.driversHHMs?.householdMembers?.newMembers;
            var storedHhmAsDrivers = context[reqVehicleClass]?.driversHHMs?.householdMembers?.storedMembers;
            storedHhmAsDrivers = storedHhmAsDrivers?.filter(hhm => hhm?.editType === "Add as driver on policy.")

            const newDrivers = addedDrivers?.length > 0 ? addedDrivers : addedHhmAsDrivers?.length > 0 ? addedHhmAsDrivers : storedHhmAsDrivers;

            if (newDrivers && newDrivers.length > 0) {
                var driversCopy = drivers;
                setDrivers((prevDrivers) => {
                    // Check if the new driver already exists in the current drivers
                    const newDriver = newDrivers[0];
                    const driverExists = prevDrivers.some(driver => driver?.userInfo?.fullName + " " + driver?.userInfo?.lastName === newDriver?.userInfo?.fullName + " " + newDriver?.userInfo?.lastName)

                    if (!driverExists) {
                        driversCopy = [...prevDrivers, newDriver];
                    }
                    return driversCopy;
                });

                var classChangeCopy = { ...context[reqVehicleClass] };
                classChangeCopy.driverAssignment.drivers = driversCopy;
                setVehicleClass({ ...classChangeCopy });
                // storageData.setItem(requestType + "Class", JSON.stringify(classChangeCopy))
            }
        }
    }, []);

    return (
        <>
            <div>
                {vehicles.map((vehicle, vehicleIndex) => {
                    return (
                        <div key={vehicleIndex} className="pb-2 text-dark">
                            <strong className="text-primary">
                                {"vehicleVIN" in vehicle ?
                                    <span className="text-uppercase">{vehicle.vehicleYear} {vehicle.vehicleMake} {vehicle.vehicleModel} - {vehicle.vehicleVIN}</span>
                                    :
                                    <span className="text-uppercase">{vehicle.Year} {vehicle.Make} {vehicle.Model} - {vehicle.VIN}</span>
                                }
                            </strong>
                            <VehicleDA_SaveContext.Provider
                                value={{
                                    vehicles, vehicleIndex,
                                    dob, setDob,
                                    saveDriverToVehicle,
                                    handleSingleField
                                }}
                            >
                                <VehicleDA_DriverPerVehicle drivers={drivers} />
                            </VehicleDA_SaveContext.Provider>
                        </div>
                    )
                })}
                <br />
                {/* Clear button */}
                {showClear &&
                    <button className="btn btn-default" onClick={clearDriverSelections}>
                        Clear
                    </button>
                }
            </div>
        </>
    )
}

export default VehicleDA_SelectVehicle